/* Bain & Prestige — thème Shopify. JavaScript sans dépendance. */
(function () {
  'use strict';
  var T = window.theme || { routes: {}, delivery: { min: 5, max: 7 }, locale: 'fr', currency: 'EUR' };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- utilitaires ---------- */
  var money = function (cents) {
    try { return new Intl.NumberFormat(T.locale || 'fr', { style: 'currency', currency: T.currency || 'EUR' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2) + ' €'; }
  };
  var toastTimer;
  function toast(msg) {
    var t = $('#toast'); if (!t) return;
    t.textContent = msg; t.classList.add('on');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.classList.remove('on'); }, 3200);
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }

  /* ---------- date de livraison estimée (jours ouvrés) ---------- */
  function businessDay(d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); var j = d.getDay(); if (j !== 0 && j !== 6) n--; } return d; }
  function fmtDate(d) { try { return d.toLocaleDateString(T.locale || 'fr', { weekday: 'long', day: 'numeric', month: 'long' }); } catch (e) { return d.toDateString(); } }
  function setDelivery(root) {
    var now = new Date(), a = fmtDate(businessDay(now, T.delivery.min)), b = fmtDate(businessDay(now, T.delivery.max));
    $$('[data-delivery-from]', root).forEach(function (el) { el.textContent = a; });
    $$('[data-delivery-to]', root).forEach(function (el) { el.textContent = b; });
  }

  /* ---------- bandeau d'annonces ---------- */
  var annTimer;
  function initAnnouncement() {
    clearInterval(annTimer);
    var items = $$('[data-announcement] .rot > div'); if (items.length < 2) return;
    var i = items.findIndex(function (el) { return el.classList.contains('on'); }); if (i < 0) i = 0;
    annTimer = setInterval(function () { items[i].classList.remove('on'); i = (i + 1) % items.length; items[i].classList.add('on'); }, 4200);
  }

  /* ---------- tiroir panier ---------- */
  function drawer() { return $('#cart-drawer'); }
  function overlay() { return $('[data-cart-overlay]'); }
  function openCart() { var d = drawer(); if (!d) return; d.classList.add('on'); overlay() && overlay().classList.add('on'); d.setAttribute('aria-hidden', 'false'); }
  function closeCart() { var d = drawer(); if (!d) return; d.classList.remove('on'); overlay() && overlay().classList.remove('on'); d.setAttribute('aria-hidden', 'true'); }
  function refreshCart(open) {
    return fetch(T.routes.root + '?sections=cart-drawer').then(function (r) { return r.json(); }).then(function (j) {
      var host = $('#shopify-section-cart-drawer'); if (!host || !j['cart-drawer']) return;
      var tmp = document.createElement('div'); tmp.innerHTML = j['cart-drawer'];
      var fresh = $('#shopify-section-cart-drawer', tmp) || tmp;
      host.innerHTML = fresh.id === 'shopify-section-cart-drawer' ? fresh.innerHTML : tmp.innerHTML;
      setDelivery(host);
      if (open) { // forcer le reflow pour l'animation
        var d = drawer(); if (d) { void d.offsetWidth; }
        openCart();
      }
    }).then(function () { return fetch(T.routes.cartJson).then(function (r) { return r.json(); }); }).then(function (c) {
      $$('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
    }).catch(function () {});
  }
  function addItems(items) {
    return post(T.routes.cartAdd, { items: items }).then(function () { return refreshCart(true); });
  }

  /* ---------- formulaires d'ajout (cartes produit, fiche produit) ---------- */
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f.matches || !f.matches('[data-ajax-form]')) return;
    e.preventDefault();
    var btn = $('[type=submit]', f), err = $('[data-form-error]', f);
    if (err) err.hidden = true;
    if (btn) btn.disabled = true;
    var fd = new FormData(f), item = { id: +fd.get('id'), quantity: +(fd.get('quantity') || 1) };
    var props = {}, has = false;
    fd.forEach(function (v, k) { var m = k.match(/^properties\[(.+)\]$/); if (m && v !== '') { props[m[1]] = v; has = true; } });
    if (has) item.properties = props;
    addItems([item]).catch(function (j) {
      var msg = (j && (j.description || j.message)) || 'Impossible d’ajouter cette pièce pour le moment.';
      if (err) { err.textContent = msg; err.hidden = false; } else { toast(msg); }
    }).then(function () { if (btn) btn.disabled = false; });
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    if (t.closest('[data-cart-open]')) { e.preventDefault(); refreshCart(true); return; }
    if (t.closest('[data-cart-close]') || t.closest('[data-cart-overlay]')) { closeCart(); return; }
    var q = t.closest('[data-qty-change]');
    if (q) {
      post(T.routes.cartChange, { line: +q.dataset.line, quantity: +q.dataset.quantity }).then(function () { return refreshCart(true); });
      return;
    }
    var tg = t.closest('[data-menu-toggle]');
    if (tg) {
      var open = document.body.classList.toggle('menu-ouvert');
      tg.setAttribute('aria-expanded', open ? 'true' : 'false'); return;
    }
    if (document.body.classList.contains('menu-ouvert') && t.closest('#main-menu a')) {
      document.body.classList.remove('menu-ouvert');
      var b = $('[data-menu-toggle]'); b && b.setAttribute('aria-expanded', 'false');
    }
    var hs = t.closest('[data-hotspot]');
    if (hs) { e.stopPropagation(); toggleHotspot(hs); return; }
    if (!t.closest('.fiche-hs')) $$('.fiche-hs').forEach(function (f) { f.hidden = true; });
    var qs = t.closest('[data-qty-step]');
    if (qs) {
      var inp = $('input[name=quantity]', qs.closest('form')); if (!inp) return;
      inp.value = Math.max(1, (+inp.value || 1) + (+qs.dataset.qtyStep)); return;
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeCart(); closeQuiz(); $$('.fiche-hs').forEach(function (f) { f.hidden = true; }); }
  });

  /* ---------- hotspots ---------- */
  function toggleHotspot(h) {
    var fiche = document.getElementById(h.dataset.hotspot); if (!fiche) return;
    var wasHidden = fiche.hidden;
    $$('.fiche-hs').forEach(function (f) { f.hidden = true; });
    if (!wasHidden) return;
    var sc = h.closest('[data-scene]').getBoundingClientRect(), hr = h.getBoundingClientRect();
    var x = hr.left - sc.left, y = hr.top - sc.top;
    fiche.hidden = false;
    var w = fiche.offsetWidth, hh = fiche.offsetHeight;
    fiche.style.left = Math.max(16, Math.min(x - w / 2 + 15, sc.width - w - 16)) + 'px';
    fiche.style.top = (y + hh + 50 > sc.height ? y - hh - 12 : y + 40) + 'px';
  }

  /* ---------- test de style (quiz) ---------- */
  var quizData = null, qi = 0, votes = {};
  function closeQuiz() { var q = $('#quiz'); if (q) { q.classList.remove('on'); q.setAttribute('aria-hidden', 'true'); } }
  function renderQuiz() {
    var c = $('#q-corps'); if (!c || !quizData) return;
    $$('#q-prog i').forEach(function (i, k) { i.classList.toggle('on', k <= qi); });
    var Q = quizData.questions;
    if (qi < Q.length) {
      var q = Q[qi];
      c.innerHTML = '<div class="sur" style="margin-bottom:10px">Question ' + (qi + 1) + ' sur ' + Q.length + '</div><h3 id="q-titre"></h3><div class="opts"></div>';
      $('#q-titre', c).textContent = q.t;
      q.o.forEach(function (o) {
        var b = document.createElement('button'); b.type = 'button';
        var s = document.createElement('b'); s.textContent = o[1]; b.appendChild(s); b.appendChild(document.createTextNode(o[2]));
        b.addEventListener('click', function () { if (o[0]) votes[o[0]] = (votes[o[0]] || 0) + 1; qi++; renderQuiz(); });
        $('.opts', c).appendChild(b);
      });
    } else {
      var best = Object.keys(votes).sort(function (a, b) { return votes[b] - votes[a]; })[0] || 'Riviera';
      var r = quizData.results[best] || quizData.results.Riviera;
      c.innerHTML = '<div class="sur" style="margin-bottom:10px">Votre suite</div><h3 id="q-titre"></h3><p class="muted" style="margin-bottom:22px"></p><div style="display:flex;gap:10px;flex-wrap:wrap"><a class="btn plein" id="q-voir">Voir ma suite</a><button type="button" class="btn vide" id="q-refaire">Refaire le test</button></div>';
      $('#q-titre', c).textContent = r.n;
      $('p', c).textContent = r.d + ' Nous vous montrons les pièces correspondantes.';
      $('#q-voir', c).href = (quizData.urls && quizData.urls[best]) || T.routes.root;
      $('#q-refaire', c).addEventListener('click', function () { qi = 0; votes = {}; renderQuiz(); });
    }
  }
  function openQuiz() {
    var q = $('#quiz'), d = $('#quiz-data'); if (!q || !d) return;
    if (!quizData) { try { quizData = JSON.parse(d.textContent); } catch (e) { return; } }
    qi = 0; votes = {}; renderQuiz(); q.classList.add('on'); q.setAttribute('aria-hidden', 'false');
  }
  document.addEventListener('click', function (e) {
    var t = e.target; if (!t.closest) return;
    if (t.closest('[data-quiz]')) { openQuiz(); return; }
    if (t.closest('#q-fermer') || t.id === 'quiz') closeQuiz();
  });

  /* ---------- composer de suite ---------- */
  function initComposer(root) {
    $$('[data-composer]', root).forEach(function (sec) {
      var on = sec.dataset.discount === 'true', tiers = [0, 0, +sec.dataset.t1 || 0, +sec.dataset.t2 || 0, +sec.dataset.t3 || 0];
      function pct(n) { return n >= 4 ? tiers[4] : tiers[Math.max(n, 0)] || 0; }
      function calc(panel) {
        var rows = $$('input[type=checkbox]', panel).filter(function (c) { return c.checked; });
        var n = rows.length, sep = 0;
        rows.forEach(function (c) { sep += +c.dataset.price; });
        var p = on ? pct(n) : 0, tot = Math.round(sep * (1 - p / 100)), eco = sep - tot;
        $('[data-t-sep]', panel).textContent = money(sep);
        $('[data-t-tot]', panel).textContent = money(tot);
        var x = $('[data-t-x3]', panel); if (x) x.textContent = money(Math.round(tot / (T.installments || 3)));
        var row = $('[data-t-eco-row]', panel);
        if (row) { row.hidden = eco <= 0; $('[data-t-eco-lib]', panel).textContent = 'Remise de la suite (−' + p + ' %)'; $('[data-t-eco]', panel).textContent = '− ' + money(eco); }
        var bar = $('[data-palier]', panel), txt = $('[data-palier-txt]', panel);
        if (bar && txt) {
          var next = [2, 3, 4].filter(function (k) { return k > n && tiers[k] > tiers[Math.min(n, 4)]; })[0];
          bar.style.width = Math.min(100, (n / 4) * 100) + '%';
          txt.textContent = next ? 'Encore ' + (next - n) + ' pièce' + (next - n > 1 ? 's' : '') + ' pour −' + tiers[next] + ' %' : (p ? 'Remise maximale atteinte.' : '');
        }
        $('[data-add-suite]', panel).disabled = n === 0;
      }
      $$('[data-suite-panel]', sec).forEach(function (panel) {
        panel.addEventListener('change', function () { calc(panel); }); calc(panel);
        $('[data-add-suite]', panel).addEventListener('click', function (e) {
          var items = $$('input[type=checkbox]', panel).filter(function (c) { return c.checked; }).map(function (c) { return { id: +c.dataset.variant, quantity: 1 }; });
          if (!items.length) return;
          var b = e.currentTarget; b.disabled = true;
          addItems(items).catch(function (j) { toast((j && j.description) || 'Impossible d’ajouter la suite pour le moment.'); }).then(function () { b.disabled = false; });
        });
      });
      $$('[data-suite-tab]', sec).forEach(function (tab) {
        tab.addEventListener('click', function () {
          $$('[data-suite-tab]', sec).forEach(function (t) { t.setAttribute('aria-pressed', t === tab ? 'true' : 'false'); });
          $$('[data-suite-panel]', sec).forEach(function (p) { p.hidden = p.dataset.suitePanel !== tab.dataset.suiteTab; });
        });
      });
    });
  }

  /* ---------- fiche produit ---------- */
  function initProduct(root) {
    $$('[data-product-page]', root).forEach(function (page) {
      var jsonEl = $('[data-product-json]', page), p; if (!jsonEl) return;
      try { p = JSON.parse(jsonEl.textContent); } catch (e) { return; }
      var form = $('#product-form', page), idInput = $('[data-variant-id]', page);
      var addBtn = $('[data-add-btn]', page), label = $('[data-add-label]', page);
      var sticky = $('[data-sticky-bar]', page), stickyBtn = $('[data-sticky-add]', page), stickyPrice = $('[data-sticky-price]', page);

      // galerie
      function showMedia(id) {
        $$('[data-media]', page).forEach(function (m) { m.hidden = String(m.dataset.media) !== String(id); });
        $$('[data-thumb]', page).forEach(function (b) { b.setAttribute('aria-selected', String(b.dataset.thumb) === String(id) ? 'true' : 'false'); });
      }
      $$('[data-thumb]', page).forEach(function (b) { b.addEventListener('click', function () { showMedia(b.dataset.thumb); }); });

      // variantes
      function current() {
        var chosen = $$('[data-option]', page).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
        if (!chosen.length) return p.variants[0];
        return p.variants.filter(function (v) { return chosen.every(function (val, i) { return v['option' + (i + 1)] === val; }); })[0];
      }
      function priceHTML(v) {
        var h = '<b class="tab" data-price>' + money(v.price) + '</b>';
        if (v.compare_at_price && v.compare_at_price > v.price) {
          h += '<span class="barre tab" data-compare>' + money(v.compare_at_price) + '</span><span class="remise" data-pct>−' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + ' %</span>';
        }
        return h;
      }
      function update() {
        var v = current();
        if (!v) { addBtn.disabled = true; label.textContent = 'Indisponible'; if (stickyBtn) stickyBtn.disabled = true; return; }
        idInput.value = v.id;
        var block = $('[data-price-block]', page); if (block) block.innerHTML = priceHTML(v);
        var x3 = $('[data-x3]', page); if (x3) x3.textContent = money(Math.round(v.price / (T.installments || 3)));
        if (stickyPrice) stickyPrice.textContent = money(v.price);
        var ap = $('[data-add-price]', page); if (ap) ap.textContent = money(v.price);
        var ec = $('[data-econo]', page);
        if (ec) { var sv = (v.compare_at_price || 0) - v.price; ec.hidden = !(sv > 0); var ev = $('[data-econo-val]', ec); if (ev && sv > 0) ev.textContent = money(sv); }
        addBtn.disabled = !v.available; label.textContent = v.available ? (label.getAttribute('data-label') || 'Ajouter au panier') : 'Épuisé';
        if (stickyBtn) stickyBtn.disabled = !v.available;
        var st = $('[data-stock]', page);
        if (st) { var d = $('.dispo', st), r = $('.rupture', st); if (d) d.hidden = !v.available; if (r) r.hidden = v.available; }
        if (v.featured_media && v.featured_media.id) showMedia(v.featured_media.id);
        try { history.replaceState(null, '', '?variant=' + v.id); } catch (e) {}
      }
      $$('[data-option] input', page).forEach(function (i) { i.addEventListener('change', update); });

      // barre collante mobile
      if (sticky && addBtn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          var visible = en[0].isIntersecting;
          sticky.classList.toggle('on', !visible && en[0].boundingClientRect.top < 0);
          sticky.setAttribute('aria-hidden', visible ? 'true' : 'false');
        }).observe(addBtn);
      }
      if (stickyBtn && form) stickyBtn.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });
    });
  }

  /* ---------- compte à rebours de l'offre ---------- */
  function initCountdown(root) {
    var els = $$('[data-countdown-end]', root); if (!els.length) return;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      els.forEach(function (el) {
        var end = new Date(el.dataset.countdownEnd).getTime(), d = end - Date.now(), box = el.closest('.urgence');
        if (isNaN(end) || d <= 0) { var row = el.closest('.urg-ligne'); if (row) row.hidden = true; if (box && !$('.urg-ligne:not([hidden])', box)) box.hidden = true; return; }
        var j = Math.floor(d / 864e5), h = Math.floor(d % 864e5 / 36e5), m = Math.floor(d % 36e5 / 6e4), s = Math.floor(d % 6e4 / 1e3);
        el.innerHTML = (j ? '<b>' + j + '</b> j ' : '') + '<b>' + pad(h) + '</b> h <b>' + pad(m) + '</b> min <b>' + pad(s) + '</b> s';
      });
    }
    tick(); setInterval(tick, 1000);
  }

  /* ---------- collection : filtres et tri ---------- */
  function initFilters(root) {
    $$('[data-filter-form]', root).forEach(function (f) {
      $$('input[type=checkbox], select[data-sort]', f).forEach(function (el) { el.addEventListener('change', function () { f.submit(); }); });
      $$('input[type=number]', f).forEach(function (el) { el.addEventListener('change', function () { f.submit(); }); });
    });
  }

  /* ---------- recommandations ---------- */
  function initRecs(root) {
    $$('[data-recs]', root).forEach(function (el) {
      var url = el.dataset.url; if (!url || el.querySelector('.produits')) return;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fresh = $('[data-recs]', tmp);
        if (fresh && fresh.querySelector('.produits')) el.innerHTML = fresh.innerHTML;
      }).catch(function () {});
    });
  }

  /* ---------- démarrage ---------- */
  function init(root) { setDelivery(root); initComposer(root); initProduct(root); initCountdown(root); initFilters(root); initRecs(root); }
  function boot() { init(document); initAnnouncement(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  // éditeur de thème : réinitialiser une section rechargée
  document.addEventListener('shopify:section:load', function (e) { init(e.target); initAnnouncement(); });
})();

/* Carrousels d'avis */
(function () {
  document.querySelectorAll('[data-mini-tp]').forEach(function (m) {
    var cartes = document.querySelectorAll('#avis-trustpilot .tp-carte, #avis-trustpilot .tp-c');
    var piste = m.querySelector('[data-car-piste]');
    if (!cartes.length || !piste) return;
    cartes.forEach(function (c) {
      var k = c.cloneNode(true); k.removeAttribute('data-shopify-editor-block');
      k.className = 'tp-carte';
      if (!k.querySelector('.tp-carte-txt')) { var t = document.createElement('div'); t.className = 'tp-carte-txt'; while (k.firstChild) t.appendChild(k.firstChild); k.appendChild(t); }
      piste.appendChild(k);
    });
    m.hidden = false;
    var points = document.createElement('div'); points.className = 'car-points';
    var nb = piste.children.length;
    for (var i = 0; i < nb; i++) { var d = document.createElement('button'); d.type = 'button'; d.setAttribute('aria-label', 'Avis ' + (i + 1)); points.appendChild(d); }
    m.appendChild(points);
    function aller(i) { var f = piste.children[i]; if (f) piste.scrollTo({ left: f.offsetLeft - piste.offsetLeft, behavior: 'smooth' }); }
    function actif() {
      var i = 0, best = 1e9;
      Array.prototype.forEach.call(piste.children, function (c, n) { var d = Math.abs(c.offsetLeft - piste.offsetLeft - piste.scrollLeft); if (d < best) { best = d; i = n; } });
      if (piste.scrollLeft + piste.clientWidth >= piste.scrollWidth - 4) i = nb - 1;
      Array.prototype.forEach.call(points.children, function (b, n) { b.classList.toggle('on', n === i); });
      return i;
    }
    Array.prototype.forEach.call(points.children, function (b, n) { b.addEventListener('click', function () { aller(n); }); });
    piste.addEventListener('scroll', actif, { passive: true }); actif();
    var pause = false;
    ['mouseenter', 'touchstart', 'focusin'].forEach(function (e) { m.addEventListener(e, function () { pause = true; }, { passive: true }); });
    ['mouseleave', 'focusout'].forEach(function (e) { m.addEventListener(e, function () { pause = false; }); });
    m.addEventListener('touchend', function () { setTimeout(function () { pause = false; }, 6000); }, { passive: true });
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setInterval(function () {
        if (pause || document.hidden) return;
        var r = m.getBoundingClientRect(); if (r.bottom < 0 || r.top > window.innerHeight) return;
        var fin = piste.scrollLeft + piste.clientWidth >= piste.scrollWidth - 4;
        if (fin) piste.scrollTo({ left: 0, behavior: 'smooth' }); else aller(actif() + 1);
      }, 4500);
    }
  });
  document.querySelectorAll('[data-carrousel]').forEach(function (c) {
    var p = c.querySelector('[data-car-piste]'); if (!p) return;
    function pas() { var f = p.firstElementChild; return f ? f.getBoundingClientRect().width + 12 : p.clientWidth; }
    var prev = c.querySelector('[data-car-prev]'), next = c.querySelector('[data-car-next]');
    if (prev) prev.addEventListener('click', function () { p.scrollBy({ left: -pas(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { p.scrollBy({ left: pas(), behavior: 'smooth' }); });
  });
})();

/* Histoire produit (section sombre) : l'image fixe change selon le texte au centre de l'écran */
(function () {
  document.querySelectorAll('[data-hist-sombre]').forEach(function (root) {
    var blocs = Array.prototype.slice.call(root.querySelectorAll('[data-hist-bloc]'));
    var imgs = Array.prototype.slice.call(root.querySelectorAll('[data-hist-img]'));
    if (!blocs.length || !imgs.length) return;
    var actif = 0, attente = false;
    function maj() {
      attente = false;
      var r = root.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      var seuil = window.innerHeight * (window.innerWidth < 900 ? 0.8 : 0.62), i = 0;
      blocs.forEach(function (b, n) { var rb = b.getBoundingClientRect(); if (rb.top + rb.height / 2 <= seuil) i = n; });
      if (i === actif) return;
      actif = i;
      imgs.forEach(function (im, n) { im.classList.toggle('actif', n === i); });
    }
    function demande() { if (!attente) { attente = true; requestAnimationFrame(maj); } }
    window.addEventListener('scroll', demande, { passive: true });
    window.addEventListener('resize', demande);
    maj();
  });
})();
